import { SearchTarget } from '@/types'

export interface BibliographyAuthorityCompleteWorksSearchRequest {
  searchTarget: SearchTarget
  numberOfLimit: number
  completeWorks: string
  completeWorksNo: string
}

export function BibliographyAuthorityCompleteWorksSearchRequestToJSON(
  value: BibliographyAuthorityCompleteWorksSearchRequest
): any {
  return {
    search_target: value.searchTarget ?? undefined,
    number_of_limit: value.numberOfLimit ?? undefined,
    complete_works:
      value.completeWorks !== '' ? value.completeWorks : undefined,
    complete_works_no:
      value.completeWorksNo !== '' ? value.completeWorksNo : undefined
  }
}
